import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export class EventContractChainContract {
  strikePrice = ""
  strikePriceCeiling = ""
  strikeType = ""
  yesSymbol = ""
  yesStreamerSymbol = ""
  noSymbol = ""
  noStreamerSymbol = ""
}

export const EVENT_CONTRACT_CHAIN_CONTRACT_DESER: SchemaDeSer<EventContractChainContract> =
  new SchemaDeSerBuilder(EventContractChainContract)
    .ofString("strikePrice", "strike-price")
    .ofString("strikePriceCeiling", "strike-price-ceiling")
    .ofString("strikeType", "strike-type")
    .ofString("yesSymbol", "yes-symbol")
    .ofString("yesStreamerSymbol", "yes-streamer-symbol")
    .ofString("noSymbol", "no-symbol")
    .ofString("noStreamerSymbol", "no-streamer-symbol")
    .toDeSer()

export class EventContractChainItem {
  frequency = ""
  category = ""
  subCategory = ""
  exchange = ""
  underlyingProduct = ""
  underlyingProductType = ""
  startsTradingAt = ""
  stopsTradingAt = ""
  contracts: EventContractChainContract[] = []
}

export const EVENT_CONTRACT_CHAIN_ITEM_DESER: SchemaDeSer<EventContractChainItem> =
  new SchemaDeSerBuilder(EventContractChainItem)
    .ofString("frequency")
    .ofString("category")
    .ofString("subCategory", "sub-category")
    .ofString("exchange")
    .ofString("underlyingProduct", "underlying-product")
    .ofString("underlyingProductType", "underlying-product-type")
    .ofString("startsTradingAt", "starts-trading-at")
    .ofString("stopsTradingAt", "stops-trading-at")
    .ofArray(
      "contracts",
      EVENT_CONTRACT_CHAIN_CONTRACT_DESER,
      EventContractChainContract
    )
    .toDeSer()

export class EventContractChainList {
  events: EventContractChainItem[] = []
}

export const EVENT_CONTRACT_CHAIN_LIST_DESER: SchemaDeSer<EventContractChainList> =
  new SchemaDeSerBuilder(EventContractChainList)
    .ofArray("events", EVENT_CONTRACT_CHAIN_ITEM_DESER, EventContractChainItem)
    .toDeSer()

export class EventContractChainEvent {
  productCategory = ""
  symbol = ""
  startsTradingAt = ""
  stopsTradingAt = ""
  contracts: EventContractChainContract[] = []
}

export const EVENT_CONTRACT_CHAIN_EVENT_DESER: SchemaDeSer<EventContractChainEvent> =
  new SchemaDeSerBuilder(EventContractChainEvent)
    .ofString("productCategory", "product-category")
    .ofString("symbol")
    .ofString("startsTradingAt", "starts-trading-at")
    .ofString("stopsTradingAt", "stops-trading-at")
    .ofArray(
      "contracts",
      EVENT_CONTRACT_CHAIN_CONTRACT_DESER,
      EventContractChainContract
    )
    .toDeSer()

export class EventContractChainDay {
  settlementDate = ""
  events: EventContractChainEvent[] = []
}

export const EVENT_CONTRACT_CHAIN_DAY_DESER: SchemaDeSer<EventContractChainDay> =
  new SchemaDeSerBuilder(EventContractChainDay)
    .ofString("settlementDate", "settlement-date")
    .ofArray(
      "events",
      EVENT_CONTRACT_CHAIN_EVENT_DESER,
      EventContractChainEvent
    )
    .toDeSer()

export class EventContractChain {
  groupCode = ""
  days: EventContractChainDay[] = []
}

export const EVENT_CONTRACT_CHAIN_DESER: SchemaDeSer<EventContractChain> =
  new SchemaDeSerBuilder(EventContractChain)
    .ofString("groupCode", "group-code")
    .ofArray("days", EVENT_CONTRACT_CHAIN_DAY_DESER, EventContractChainDay)
    .toDeSer()
